import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_EDUCATIONS, SET_EMPLOYEE_EDUCATION, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_EDUCATION_ISLOADING,
  DELETE_EMPLOYEE_EDUCATION,
  EDIT_EMPLOYEE_EDUCATION,
  GET_EMPLOYEE_EDUCATIONS,
  GET_EMPLOYEE_EDUCATION,
  REGISTER_EMPLOYEE_EDUCATION,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeeEducation from '@/services/employee_education';
import { Module } from 'vuex';
import { EditEmployeeEducation, RegisterEmployeeEducation, GetEmployeeEducation } from '@/dtos/employee_education.dto';

const employeeEducation: Module<any, {}> = {
  state: {
    employeeEducation: {
      data: null,
      isLoading: false,
    },
    employeeEducations: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeeEducation: (state: { employeeEducation: any }) => state.employeeEducation,
    employeeEducations: (state: { employeeEducations: any }) => state.employeeEducations,
  },
  mutations: {
    [SET_EMPLOYEE_EDUCATION]: (
      state: { employeeEducation: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeEducation.data = payload.data) : null,
        (state.employeeEducation.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_EDUCATIONS]: (
      state: { employeeEducations: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeEducations.data = payload.data) : null,
        (state.employeeEducations.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_EDUCATION]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_EDUCATION, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeEducation.registerEmployeeEducation(
        payload as RegisterEmployeeEducation
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_EDUCATION, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_EDUCATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_EDUCATION, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_EDUCATIONS]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_EDUCATIONS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeEducation.getEmployeeEducations(
        payload as GetEmployeeEducation
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_EDUCATIONS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_EDUCATIONS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_EDUCATIONS, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_EDUCATION]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_EDUCATIONS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeEducation.getEmployeeEducations(
        payload as GetEmployeeEducation
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_EDUCATIONS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_EDUCATIONS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_EDUCATIONS, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_EDUCATION]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_EDUCATION, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeEducation.editEmployeeEducation(
        payload as EditEmployeeEducation
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_EDUCATION, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_EDUCATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_EDUCATION, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_EDUCATION]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_EDUCATION, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeEducation.deleteEmployeeEducation(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_EDUCATION, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_EDUCATION, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_EDUCATION, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_EDUCATION_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_EDUCATION, { isLoading: false });
      commit(SET_EMPLOYEE_EDUCATIONS, { isLoading: false });
    },
  },
};

export default employeeEducation;
